export var VELT_SDK_VERSION = '4.5.8-beta.7';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.5.8-beta.7': 'sha384-j2aviNPacX/b/FP6BOQCTW8GHtPXYDxIoRZ3DSR797roxtfaoZCLhGByqNzJzykf',
};
